import { safeCombineEpics } from '@cbridge-utils/redux-observable';
import { closeScheduleBeforeRemoveEpic } from './_epics/closeScheduleBeforeRemove.epic';
import { closeScheduleIntervalBeforeRemoveEpic } from './_epics/closeScheduleIntervalBeforeRemove.epic';
import { handleScheduleNotFoundEpic } from './_epics/handleScheduleNotFound.epic';
import { reloadScheduleListEpic } from './_epics/reloadScheduleList.epic';
import { toggleViewScheduleSidebarEpic } from './_epics/toggleViewScheduleSidebar.epic';
import { toggleViewScheduleIntervalSidebarEpic } from './_epics/toggleViewScheduleIntervalSidebar.epic';
import { reloadScheduleAfterIntervalUpdateEpic } from './_epics/reloadScheduleAfterIntervalUpdate.epic';

export const controllerScheduleEpic = safeCombineEpics(
  closeScheduleBeforeRemoveEpic,
  closeScheduleIntervalBeforeRemoveEpic,
  handleScheduleNotFoundEpic,
  reloadScheduleListEpic,
  toggleViewScheduleSidebarEpic,
  toggleViewScheduleIntervalSidebarEpic,
  reloadScheduleAfterIntervalUpdateEpic,
);
